import { CanDeactivateFn } from '@angular/router';

interface HasDirtyState {
  isQuoteDirty?: boolean;
}

export const quoteUnsavedGuard: CanDeactivateFn<HasDirtyState> = (component) => {
  if (!component?.isQuoteDirty) return true;
  return confirm('You have unsaved changes. Leave without saving?');
};
